// // import React, { useContext } from "react";
// // import { AppBar, Toolbar, Typography, Button, Box } from "@mui/material";
// // import { Link } from "react-router-dom";
// // import useAuth from "../hooks/useAuth";

// // const Navbar = () => {
// //   const { isAuthenticated, logout } = useAuth();

// //   return (
// //     <AppBar position="static">
// //       <Toolbar>
// //         <Typography
// //           variant="h6"
// //           component={Link}
// //           sx={{ flexGrow: 1, textDecoration: "none", color: "inherit" }}
// //           to="/"
// //         >
// //           On The Farm
// //         </Typography>
// //         <Box>
// //           {isAuthenticated ? (
// //             <Button color="inherit" onClick={logout}>
// //               Logout
// //             </Button>
// //           ) : (
// //             <>
// //               <Button color="inherit" component={Link} to="/login">
// //                 Login
// //               </Button>
// //               <Button color="inherit" component={Link} to="/signup">
// //                 Sign Up
// //               </Button>
// //             </>
// //           )}
// //         </Box>
// //       </Toolbar>
// //     </AppBar>
// //   );
// // };

// // export default Navbar;

// import React from "react";
// import { AppBar, Toolbar, Typography, Button, Box, Stack } from "@mui/material";
// import { Link } from "react-router-dom";
// import PetsIcon from "@mui/icons-material/Pets";
// import useAuth from "../hooks/useAuth";

// const Navbar = () => {
//   const { isAuthenticated, logout } = useAuth();

//   return (
//     <AppBar
//       position="sticky"
//       elevation={0}
//       sx={{
//         background:
//           "linear-gradient(135deg, rgba(30,144,255,0.85), rgba(0,191,255,0.85))",
//         backdropFilter: "blur(8px)",
//         borderBottom: (t) => `1px solid ${t.palette.divider}`,
//       }}
//     >
//       <Toolbar sx={{ minHeight: 64 }}>
//         <Stack
//           direction="row"
//           alignItems="center"
//           spacing={1}
//           component={Link}
//           to="/"
//           style={{ textDecoration: "none" }}
//           sx={{ color: "inherit", flexGrow: 1 }}
//         >
//           <PetsIcon />
//           <Typography variant="h6" sx={{ fontWeight: 700 }}>
//             OnTheFarm Today
//           </Typography>
//         </Stack>

//         <Box>
//           {isAuthenticated ? (
//             <Button
//               color="inherit"
//               onClick={logout}
//               sx={{
//                 borderRadius: 999,
//                 px: 2,
//                 border: "1px solid rgba(255,255,255,0.6)",
//                 ml: 1,
//               }}
//               variant="outlined"
//             >
//               Logout
//             </Button>
//           ) : (
//             <>
//               <Button
//                 color="inherit"
//                 component={Link}
//                 to="/login"
//                 sx={{ borderRadius: 999, px: 2 }}
//               >
//                 Login
//               </Button>
//               <Button
//                 component={Link}
//                 to="/signup"
//                 variant="contained"
//                 sx={{
//                   borderRadius: 999,
//                   px: 2.2,
//                   ml: 1,
//                   color: "primary.contrastText",
//                   background:
//                     "linear-gradient(135deg, #1E90FF 0%, #00BFFF 100%)",
//                   boxShadow: "0 6px 14px rgba(0,0,0,0.2)",
//                   "&:hover": { filter: "brightness(.95)" },
//                 }}
//               >
//                 Sign Up
//               </Button>
//             </>
//           )}
//         </Box>
//       </Toolbar>
//     </AppBar>
//   );
// };

// export default Navbar;

// src/components/Navbar.jsx
import React from "react";
import { AppBar, Toolbar, Button, Box, Stack, IconButton } from "@mui/material";
import { Link } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import LivestockIcon from "./icons/LivestockIcon";
import useAuth from "../hooks/useAuth";
import UserAccountMenu from "./UserAccountMenu";
import { APP_HOME_PATH } from "../config/routes";

const APP_LOGO_WHITE = `${process.env.PUBLIC_URL || ""}/white_on_trans.png`;

const Navbar = ({ onOpenSidebar }) => {
  const { isAuthenticated } = useAuth();

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        width: "100%",
        maxWidth: "100vw",
        left: 0,
        right: 0,
        overflow: "hidden",
        background:
          "linear-gradient(135deg, rgba(42, 152, 255, 0.85), rgba(2, 130, 172, 0.85))",
        backdropFilter: "blur(8px)",
        borderBottom: (t) => `1px solid ${t.palette.divider}`,
      }}
    >
      <Toolbar
        sx={{
          minHeight: { xs: 66, sm: 74 },
          px: { xs: 1, sm: 2 },
          gap: 0.5,
          justifyContent: "space-between",
          position: "relative",
          width: "100%",
          maxWidth: "100%",
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          sx={{
            flex: "1 1 0",
            minWidth: 0,
            justifyContent: "flex-start",
          }}
        >
          {onOpenSidebar ? (
            <Box sx={{ display: { xs: "inline-flex", md: "none" } }}>
              <IconButton
                color="inherit"
                onClick={onOpenSidebar}
                aria-label="open menu"
              >
                <MenuIcon />
              </IconButton>
            </Box>
          ) : (
            <Box
              sx={{ display: { xs: "inline-flex", md: "none" }, width: 48 }}
              aria-hidden
            />
          )}
        </Stack>

        <Box
          component={Link}
          to={APP_HOME_PATH}
          sx={{
            position: "absolute",
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%)",
            textDecoration: "none",
            display: "inline-flex",
            alignItems: "center",
            zIndex: 1,
          }}
        >
          <Box
            component="img"
            src={APP_LOGO_WHITE}
            alt="OnTheFarm Today"
            sx={{
              height: { xs: 36, sm: 50, md: 62 },
              width: "auto",
              maxWidth: { xs: "42vw", sm: 200, md: "none" },
              display: "block",
              objectFit: "contain",
              filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.25))",
            }}
          />
        </Box>

        <Box
          sx={{
            flex: "1 1 0",
            minWidth: 0,
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            gap: { xs: 0.5, sm: 1 },
          }}
        >
          {isAuthenticated ? (
            <>
              <Box
                sx={{
                  display: { xs: "none", lg: "flex" },
                  alignItems: "center",
                  gap: 0.75,
                  mr: 0.5,
                }}
              >
                <Button
                  color="inherit"
                  component={Link}
                  to="/animals"
                  size="small"
                  startIcon={<LivestockIcon sx={{ fontSize: 20 }} />}
                  sx={{
                    borderRadius: 999,
                    px: 1.5,
                    display: { xs: "none", md: "inline-flex" },
                    border: "1px solid rgba(255,255,255,0.45)",
                  }}
                >
                  Animals
                </Button>
                <Button
                  color="inherit"
                  component={Link}
                  to="/treatments"
                  size="small"
                  startIcon={<LocalHospitalIcon sx={{ fontSize: 20 }} />}
                  sx={{
                    borderRadius: 999,
                    px: 1.5,
                    display: { xs: "none", md: "inline-flex" },
                    border: "1px solid rgba(255,255,255,0.45)",
                  }}
                >
                  Treatments
                </Button>
              </Box>
              <UserAccountMenu />
            </>
          ) : (
            <>
              <Button
                color="inherit"
                component={Link}
                to="/login"
                sx={{ borderRadius: 999, px: 2 }}
              >
                Login
              </Button>
              <Button
                component={Link}
                to="/signup"
                variant="contained"
                sx={{
                  borderRadius: 999,
                  px: 2.2,
                  ml: 1,
                  color: "primary.contrastText",
                  background:
                    "linear-gradient(135deg, #1E90FF 0%, #00BFFF 100%)",
                  boxShadow: "0 6px 14px rgba(0,0,0,0.2)",
                  "&:hover": { filter: "brightness(.95)" },
                }}
              >
                Sign Up
              </Button>
            </>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
